/**
 * Supplier Form Fields.
 * @format
 */

export const supplierFormFields = [
  {
    fieldTitle: 'Company name',
    fieldName: 'Company',
    id: 'company',
    type: 'text',
    placeholderText: "Your company's name",
    errorMessage: 'Company name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'First name',
    fieldName: 'FirstName',
    id: 'first-name',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last name',
    fieldName: 'LastName',
    id: 'last-name',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Phone number',
    fieldName: 'Phone number',
    id: 'phone',
    type: 'text',
    placeholderText: '(000) 000 - 0000',
    errorMessage: 'Invalid email.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Preferred contact method',
    fieldName: 'Preferred contact method',
    id: 'preferred-contact-method',
    type: 'checkbox',
    errorMessage: 'Preferred contact method required.',
    required: false,
    list: [
      { name: 'Email', value: 'Email' },
      { name: 'Phone', value: 'Phone' },
      { name: 'Other', value: 'Other Contact Method' },
    ],
    useNameAsLookupValue: true,
  },
  {
    fieldTitle: 'Company Address',
    fieldName: 'CompnayAddress',
    id: 'company-address',
    type: 'text',
    placeholderText: '',
    errorMessage: 'Company address required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Company Website',
    fieldName: 'CompnayWebsite',
    id: 'company-website',
    type: 'text',
    placeholderText: 'https://www.varian.com/',
    errorMessage: 'Company website required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle:
      'Is your company certified as a minority-owned business? Multiple selections. Select "N/A" if none.',
    fieldName: 'Certified Minority Owned',
    id: 'company-certification',
    type: 'checkbox',
    errorMessage: 'Company certification field required.',
    required: false,
    list: [
      {
        name: 'Veteran-Owned Business Concern',
        value: 'Veteran-Owned Business Concern',
      },
      {
        name: 'Service-Disabled Veteran-Owned Business Concern',
        value: 'Service-Disabled Veteran-Owned Business Concern',
      },
      {
        name: 'Foreign Business',
        value: 'Foreign Business',
      },
      { name: 'HUB Zone Business Concern', value: 'HUB Zone Business Concern' },
      { name: 'Large Business Concern', value: 'Large Business Concern' },
      {
        name: 'Small Disadvantaged Business Concern',
        value: 'Small Disadvantaged Business Concern',
      },
      { name: 'Small Business Concern', value: 'Small Business Concern' },
      {
        name: 'Women-Owned Small Business Concern',
        value: 'Women-Owned Small Business Concern',
      },
      {
        name: 'Women-Owned Small Disadvantage Concern',
        value: 'Women-Owned Small Disadvantage Concern',
      },
      {
        name: 'N/A',
        value: 'N/A',
      },
      { name: 'Other', value: 'Other Company Certification' },
    ],
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Company operating regions',
    fieldName: 'Operating Regions',
    id: 'operating-regions',
    type: 'checkbox',
    errorMessage: 'Company operating regions field required.',
    required: false,
    list: [
      { name: 'North America', value: 'North America' },
      { name: 'Central and South America', value: 'Central and South America' },
      {
        name: 'Western and Northern Europe',
        value: 'Western and Northern Europe',
      },
      { name: 'Eastern Europe and Russia', value: 'Eastern Europe and Russia' },
      { name: 'Middle East', value: 'Middle East' },
      { name: 'Africa', value: 'Africa' },
      { name: 'Asia Pacific', value: 'Asia Pacific' },
    ],
    useNameAsLookupValue: false,
  },
];
